<template>
  <div v-if="cookieCheck" class="cookie-hint" v-bind="$attrs">
    <p>
      {{ $t('cookiebanner.text') }}
      <BaseLink :link="link" :class="$style.link">{{ $t('cookiebanner.privacy') }}</BaseLink>
    </p>
    <div :class="$style.button">
      <BaseButton type="secondary" outlined @click.native="setCookieConsent">{{
        $t('cookiebanner.btn')
      }}</BaseButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCookie',
  props: {
    link: {
      type: String,
      required: true,
    },
  },
  computed: {
    cookieCheck() {
      const consentCookie = this.getCookie('cookieconsent')
      return !consentCookie
    },
  },
  methods: {
    setCookie(cName = 'cookieconsent', value = 1, exdays = null) {
      let exdate
      if (exdays) {
        exdate = new Date()
        exdate.setDate(exdate.getDate() + exdays)
      } else {
        // 10 Years if exdays not specified
        exdate = new Date()
        exdate.setDate(exdate.getDate() + 3650)
      }
      const cValue = escape(value) + (exdays === 0 ? '' : '; expires=' + exdate.toUTCString())
      document.cookie = cName + '=' + cValue + '; path=/'
    },
    getCookie(cName) {
      const ARRcookies = document.cookie.split(';')
      for (let i = 0; i < ARRcookies.length; i++) {
        let x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='))
        const y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1)
        x = x.replace(/^\s+|\s+$/g, '')
        // eslint-disable-next-line eqeqeq
        if (x == cName) {
          return unescape(y)
        }
      }
    },
    setCookieConsent() {
      const consentEl = document.querySelector('.cookie-hint')
      consentEl.classList.add('fadeOut')
      this.setCookie('cookieconsent', true)
    },
  },
}
</script>

<style lang="scss" module>
:global(.cookie-hint) {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    flex-direction: row;

    p {
      font-size: var(--font-base);
    }
  }
  position: fixed;

  right: 0;
  bottom: 0;
  left: 0;

  z-index: 100;

  display: flex;
  flex-direction: column;
  padding: 1rem;

  background-color: var(--primary);

  transition: all 0.5s;

  p {
    font-size: var(--font-xs);
  }
}

:global(.fadeOut) {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    bottom: -12rem;
  }
  bottom: -20rem;
}

.button {
  display: flex;

  align-items: center;
  justify-content: flex-end;
  min-width: 15rem;

  margin-left: 2rem;
}

.link {
  color: var(--black) !important;
}
</style>
